<app-navigation-bar></app-navigation-bar>
<router-outlet></router-outlet>
<app-footer class="mt-auto"></app-footer>
<app-promotion-modal></app-promotion-modal>
